export default __webpack_public_path__ + "static/media/order.b24ffd62.svg";